import { render, staticRenderFns } from "./BankAccountsPage.vue?vue&type=template&id=6e9e95fa&scoped=true&"
import script from "./BankAccountsPage.vue?vue&type=script&lang=js&"
export * from "./BankAccountsPage.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountsPage.vue?vue&type=style&index=0&id=6e9e95fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9e95fa",
  null
  
)

export default component.exports